import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * useFinestraIndietro — il tasto «Indietro» chiude la finestra aperta sopra
 * la pagina e resta sulla schermata sotto (Alex, 28 settembre 2026).
 *
 * Aprendo la finestra si aggiunge un passo alla cronologia: lo STESSO
 * indirizzo, con un segno nello stato della navigazione. «Indietro» toglie
 * quel passo, il segno sparisce, e la finestra si chiude con la sua
 * funzione di chiusura - che chiede, se c'e' qualcosa di non salvato, come
 * col clic su «Annulla». Se la risposta e' no, il passo si rimette.
 * Chiusa dall'interfaccia, il passo si toglie, cosi' il prossimo «Indietro»
 * non riapre niente e va davvero indietro.
 *
 * Il tablet in sala d'attesa NON la usa: li' la cronologia non deve avere
 * passi con i dati di un paziente (vedi pages/Tablet.jsx).
 *
 * @param {boolean}  aperta
 * @param {function} chiudi  chiude la finestra (puo' chiedere e non chiudere)
 */
export function useFinestraIndietro(aperta, chiudi) {
    const navigate = useNavigate();
    const location = useLocation();
    const chiave = useRef(null);
    const chiudiOra = useRef(chiudi);
    chiudiOra.current = chiudi;
    const tornando = useRef(false);

    /* Aperta: un passo in piu', stesso indirizzo, col segno. */
    useEffect(() => {
        if (aperta && !chiave.current) {
            chiave.current = `f${Date.now()}${Math.random().toString(36).slice(2, 6)}`;
            navigate(`${location.pathname}${location.search}`,
                { state: { ...(location.state || {}), finestra: chiave.current } });
        }
        /* Chiusa dall'interfaccia mentre il passo c'e' ancora: si toglie. */
        if (!aperta && chiave.current && !tornando.current) {
            const k = chiave.current;
            chiave.current = null;
            if (location.state?.finestra === k) navigate(-1);
        }
        if (!aperta) tornando.current = false;
        // eslint-disable-next-line
    }, [aperta]);

    /* «Indietro»: il segno non c'e' piu' e la finestra e' ancora aperta. */
    useEffect(() => {
        if (!aperta || !chiave.current) return;
        if (location.state?.finestra === chiave.current) return;
        tornando.current = true;
        const k = chiave.current;
        chiave.current = null;
        chiudiOra.current();
        /* Se chi chiude ha chiesto e la risposta e' stata no, la finestra
           resta: si rimette il passo, al prossimo giro. */
        setTimeout(() => {
            if (tornando.current && !chiave.current) {
                chiave.current = k;
                navigate(`${location.pathname}${location.search}`,
                    { state: { ...(location.state || {}), finestra: k } });
                tornando.current = false;
            }
        }, 0);
        // eslint-disable-next-line
    }, [location]);
}
